module.exports = __webpack_public_path__ + "img/corrigir-redacao.9a65a511.png";